<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Editar colmena/núcleo" />

        <v-form ref="form" v-model="valid" lazy-validation>

            <v-select
                    v-model="infoform.idcolmenar"
                    class="form-group"
                    color="orange"
                    :items="colmenares"
                    item-value="[id]"
                    item-text="[name]"
                    label="Colmenar*"
                    data-vv-name="infoform.idcolmenar"
                    required
                    :rules="requiredRule"
            ></v-select>


            <!--div class="position-relative form-group">
                <label for="date_created" class="">Fecha de inicio colmena</label>
                <datepicker
                        name="date_created"
                        id="date_created"
                        required
                        v-model="infoform.date_created"
                        format="dd/MM/yyyy"
                        class="form-control"></datepicker>
                <p style="color:red">{{errors.date}}</p>
            </div-->

            <p for="date_created" class=""><b>Fecha de inicio colmena*</b></p>
            <datepicker
                    name="date_created"
                    id="date_created"
                    required
                    v-model="infoform.date_created"
                    format="dd/MM/yyyy"
                    class="form-datepicker"></datepicker>
            <p class="v-messages__message">{{errors.date}}</p>


            <v-text-field
                    v-model="infoform.number"
                    color="orange"
                    label="Número de colmena/núcleo*"
                    :rules="requiredRule"

            ></v-text-field>

            <v-text-field
                    v-model="infoform.position"
                    color="orange"
                    type="number"
                    label="Posición en colmenar*"
                    :rules="requiredRule"
            ></v-text-field>


            <div class="row">
                <div class="col-d-10"><b>Núcleo</b></div>
                <div class="col-d-2">
                    <v-switch
                            color="orange"
                            v-model="infoform.core"
                            @click = "toggleclick()"
                            inset
                    ></v-switch>

                </div>
            </div>


            <div id="frames_core" style="display:none">
                <p><b>Cuadros del núcleo</b></p>
                <div class="row">

                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_breeding"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Cría"
                                :items="optionsAlza"
                        ></v-select>
                    </div>
                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_honey"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Miel"
                                :items="optionsAlza"
                        ></v-select>
                    </div>
                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_pollen"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Polen"
                                :items="optionsAlza"
                        ></v-select>
                    </div>

                </div>



                <div class="row">


                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_bee"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Abejas"
                                :items="optionsAlza"
                        ></v-select>
                    </div>

                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_lamites"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Láminas sin estirar"
                                :items="optionsAlza"
                        ></v-select>
                    </div>

                    <div class="col-d-4">
                        <v-select
                                v-model="infoform.frame_lamites_estiradas"
                                class="form-group subcheck"
                                color="amber darken-2"
                                label="Láminas estiradas"
                                :items="optionsAlza"
                        ></v-select>
                    </div>

                </div>




            </div>

            <p><b>Cuadros de la colmena*:</b> <span class="form-datepicker" style="margin-left:12px;text-align:center;">&nbsp;
                &nbsp;{{infoform.number_frames}}&nbsp;&nbsp;</span></p>

            <v-slider

                    v-model="infoform.number_frames"
                    color="orange"
                    max="10"
                    min="1"
                    value="5"
                    thumb-color="orange"
            ></v-slider>

            <b>Tipo</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="type in optionsType" :key="type.value" style="auto">
                    <input type="radio" v-model="infoform.type" :id="type.value" :value="type.value">
                    <label class="btn" :for="type.value">{{type.text}}</label>
                </div>
            </div>

            <b>Suelo</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="floor in optionsFloor" :key="floor.value" style="auto">
                    <input type="radio" v-model="infoform.floor" :id="floor.value" :value="floor.value">
                    <label class="btn" :for="floor.value">{{floor.text}}</label>
                </div>
            </div>

            <b>Origen</b>
            <div class="radio-btn-group">
                <div class="radio" v-for="origin in optionsOrigin" :key="origin.value" style="auto">
                    <input type="radio" v-model="infoform.origin" :id="origin.value" :value="origin.value">
                    <label class="btn" :for="origin.value">{{origin.text}}</label>
                </div>
            </div>

            <div class="row">
                <div class="col-d-4">
                    <b>Alza</b>
                </div>
                <div class="col-d-2">

                    <v-switch
                            color="amber darken-2"
                            v-model="infoform.alza"
                            @click="updateAlza()"
                            inset
                    ></v-switch>

                </div>
                <div class="col-d-6">
                    <v-select
                            v-model="infoform.alza_value"
                            class="form-group subcheck"
                            color="amber darken-2"
                            :items="optionsAlza"
                    ></v-select>
                </div>
            </div>



            <p><b>Descripción</b></p>
            <v-col class="col" cols="12" md="6">
                <v-textarea
                        solo
                        name="description"
                        label="Otros tipos, notas, información adicional"
                        v-model="infoform.description"
                ></v-textarea>
            </v-col>

            <loading v-bind:isloading="isloading" ></loading>

            <v-alert
                    dense
                    v-bind:type="alertForm"
                    text
                    :value="alert"
                    transition="scale-transition"
            >
                {{responseform}}
            </v-alert>

            <v-btn :disabled="!valid" class="mr-4 btn-yellow" @click="validate">
                Aceptar
            </v-btn>

        </v-form>

    </div>

</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import loading from "@/components/Loader"
import axios from "axios";
import Datepicker from 'vuejs-datepicker';

export default {
    name: 'colmena-nueva',
    components: {toolbar,loading,Datepicker},
    data() {
        return {
            toolbar: {
              return: '0',
            },
            valid: true,

            requiredRule: [
                v => !!v || 'Requerido',
                v => (v && v.length <= 25) || 'Debe ser inferior a 25 caracteres',
            ],


           isloading:'',

            alertForm:'success',
            responseform:'',
            alert: false,

            errors: {
                date:'',
            },

            optionsType: [
              { text: 'Dadant', value: 'dadant' },
              { text: 'Langstroth', value: 'langstroth' },
              { text: 'Layens', value: 'layens' }
            ],

            optionsAlza: [
              { text: '0', value: '0' },
              { text: '1', value: '1' },
              { text: '2', value: '2' },
              { text: '3', value: '3' },
              { text: '4', value: '4' },
              { text: '5', value: '5' },
              { text: '6', value: '6' },
              { text: '7', value: '7' },
              { text: '8', value: '8' },
              { text: '9', value: '9' },
              { text: '10', value: '10' }
            ],


            optionsFloor: [
              { text: 'Suelo sólido', value: 'solido' },
              { text: 'Suelo antivarroa', value: 'antivarroa' },
              { text: 'Otro', value: 'otro-suelo' }
            ],

            optionsOrigin: [
              { text: 'Producción propia', value: 'propia' },
              { text: 'Comprada', value: 'compra' },
              { text: 'Otro', value: 'otro-origen' }
            ],

            infoColmena: null,
            infoform: {
                idcolmenar: '',
                date_created: '',
                number: '',
                core: '',
                frame_breeding: '',
                frame_honey: '',
                frame_pollen: '',
                frame_lamites: '',
                frame_lamites_estiradas: '',
                frame_bee: '',

                number_frames: '',
                type: '',
                floor: '',
                origin: '',
                description: '',
                alza:'',
                alza_value:'',
                position:'',
            },

            colmenares:'',
        }
    },
    methods:{

        toggleclick(){
            var x = document.getElementById("frames_core");

            if(this.infoform.core){
                x.style.display = "block";
            }else{
                x.style.display = "none";

            }
        },

        updateAlza(){

            if(this.infoform.alza===true){
                this.infoform.alza_value = '1'
            }else{
                this.infoform.alza_value = '0'
            }
        },
        validate () {
            this.$refs.form.validate()
            if(this.infoform.date_created===''){
                this.errors.date = "Debes insertar la fecha de inicio de la colmena en el colmenar."
            }
            if(this.$refs.form.validate()){

                this.alert = false
                this.isloading = true

                this.errors.date = ''

                axios.put("https://appws.panimiel.com/new/index.php/api/colmena/"+this.$route.params.id, this.infoform)
                     .then((response) => {
                     this.responseform = response.data
                     this.alertForm = 'success'
                     this.isloading=''
                     this.alert = true
                })
                .catch((error) => {
                    this.alertForm = 'error',
                    this.isloading=''

                    if (error.response.status != 500){
                        this.responseform = error.response.data
                    }else{
                        this.responseform = 'Error, no ha sido posible editar la colmena.'
                    }
                     this.alert = true

                 })
            }
        }
    },

     created() {
     auth.getUserLogged()




        var that = this

         axios.get("https://appws.panimiel.com/new/index.php/api/colmenar").then((colmenares) => {
              that.colmenares = colmenares.data
            })



        axios.get("https://appws.panimiel.com/new/index.php/api/colmena/detail/"+this.$route.params.id).then((infoColmena) => {
          that.infoColmena = infoColmena.data

            this.infoform.idcolmenar = that.infoColmena.idcolmenar
            this.infoform.date_created = that.infoColmena.date_created
            this.infoform.number = that.infoColmena.number
            this.infoform.position = that.infoColmena.position

            if(that.infoColmena.core==='1'){
                this.infoform.core = that.infoColmena.core

                var x = document.getElementById("frames_core");
                x.style.display = "block";
            }
             this.infoform.frame_breeding = that.infoColmena.frame_breeding
             this.infoform.frame_honey = that.infoColmena.frame_honey
             this.infoform.frame_pollen = that.infoColmena.frame_pollen
             this.infoform.frame_lamites = that.infoColmena.frame_lamites
             this.infoform.frame_lamites_estiradas = that.infoColmena.frame_lamites_estiradas
             this.infoform.frame_bee = that.infoColmena.frame_bee

            this.infoform.number_frames = that.infoColmena.number_frames
            this.infoform.type = that.infoColmena.type
            this.infoform.floor = that.infoColmena.floor
            this.infoform.origin = that.infoColmena.origin
            this.infoform.description = that.infoColmena.description

            if(that.infoColmena.description === '0'){
               this.infoform.description = ''
            }

            if(that.infoColmena.alza === '1'){
               this.infoform.alza = that.infoColmena.alza
            }

            this.infoform.alza_value = that.infoColmena.alza_value
        })


      }
}

</script>

<style scoped lang="scss">
</style>